import { useQuery } from "@tanstack/react-query"
import { getCompanyById } from "@/lib/api/company.api"
import { useAuthStore } from "@/store/auth.store"

// companyId is passed explicitly from the caller (usually from the fetched profile)
// so this hook is not dependent on the auth store having sellerCompanyId set
export function useCompanyDetails(companyId: string | null | undefined, enabled: boolean) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["company", companyId],
    queryFn: () => getCompanyById(companyId!, accessToken ?? undefined),
    enabled: enabled && !!companyId,
    staleTime:0,
  })
}